<template>
  <generic-view
    :title="$t('compoundment')"
    icon="cubes"
    v-bind:show_plus="true"
    v-on:add="add"
  >
    <div class="ui list">
      <div class="item" v-for="(product, index) in products" v-bind:key="index">
        <i class="large cube middle aligned icon"></i>
        <div class="content">
          <!-- <a class="header">
            {{ item.setup.address }}
            <small>| {{ item.setup.type }}</small>
          </a>-->
          <div class="description">
            <div class="fields">
              <div class="two column wide field">
                <label v-if="index == 0">{{ $t("quantity") }}</label>
                <input type="text" v-model="products[index].quantity" />
              </div>
              <div class="ten column wide field">
                <label v-if="index == 0">{{ $t("product") }}</label>
                <div class="ui search" ref="product_search" :data-i="index">
                  <div class="ui icon input">
                    <input
                      class="prompt"
                      type="text"
                      :placeholder="$t('search product')"
                      :value="product.product.name"
                    />
                    <i class="search icon"></i>
                  </div>
                  <div class="results"></div>
                </div>
              </div>
              <div class="four column wide field">
                <label class v-if="index == 0">{{ $t("options") }}</label>
                <div class="ui tiny right floated buttons">
                  <div
                    class="ui basic icon labeled button"
                    v-on:click="remove(product, index)"
                  >
                    <i class="red trash icon"></i>
                    {{ $t("delete") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="extra">{{ item.create_date | fromNow }}</div> -->
        </div>
      </div>
    </div>
  </generic-view>
</template>

<script>
import { init_search } from "@/utils";
import GenericView from "@/components/GenericContainer";

export default {
  props: {
    product_in: Object,
  },
  components: {
    "generic-view": GenericView,
  },
  data() {
    return {
      products: [],
      // customer: {}
    };
  },
  methods: {
    add() {
      let vm = this;
      vm.products.push({ quantity: 1, product: {} });
    },
    remove(product, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove product?"),
        function() {
          vm.products.splice(index, 1);
        },
      );
    },
    getList() {
      return this.products;
    },
  },
  mounted() {
    let vm = this;
    this.processing = true;
    if (vm.product_in && vm.product_in.setup) {
      vm.products = vm.product_in.setup.compoundment || [];
    }

    // setTimeout(function() {
    //   local_api(vm, "post", "/customer_email/do-get-initial-items", {
    //     uuid: vm.$props.customer.uuid
    //   })
    //     .then(items => {
    //       vm.addresses = items;
    //       vm.all_addresses = clone(items);
    //       vm.processing = false;
    //     })
    //     .catch(err => {
    //       error_toast(err);
    //       console.error(err);
    //     });
    // }, 100);
  },
  watch: {
    products() {
      let vm = this;
      setTimeout(() => {
        let onSearchSelect = function(data) {
          let idx = window.jQuery(this).data("i");
          vm.products[idx].product = data.product;
        };
        let onSearchResponse = (data) => {
          let rslt = [];
          data.map((r) => {
            rslt.push({
              title: r.name,
              description: r.name,
              product: r,
            });
          });
          return { results: rslt };
        };

        init_search(
          vm,
          vm.$refs.product_search,
          "search product",
          onSearchResponse,
          onSearchSelect,
        );
      }, 200);
    },
  },
};
</script>
